import { render, staticRenderFns } from "./FormOwnersSelect.vue?vue&type=template&id=3c408b6e&"
import script from "./FormOwnersSelect.vue?vue&type=script&lang=js&"
export * from "./FormOwnersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports